const { Popover, MenuList, MenuItem, Button, ButtonGroup, ListItemText, withStyles } = window.Material;
const { ArrowUpward, ArrowDownward, ArrowDropDown } = window.MaterialIcons;
import {ContentContext} from "../../../../utils/contexts";

const styles = theme => ({
  button: {
    padding: '0.5rem',
    minWidth: '0',
  },
  label: {
    fontSize: '11px',
  },
});

class SortByValue extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      anchor: null,
    };
  }

  handleSortClick = event => {
    event.preventDefault();
    const { sort, setProperty, fetchContent } = this.context;

    setProperty("sort", !sort);
    fetchContent(undefined, undefined, !sort);
  };

  handleDropDownClick = event => {
    this.setState({ anchor: event.currentTarget });
  };

  closeMenu = () => {
    this.setState(() => ({ anchor: null }));
  };

  handleOnClick = name => {
    const { setProperty, fetchContent } = this.context;

    setProperty("sortByValue", name);
    fetchContent(undefined, undefined, undefined, name);

    this.closeMenu();
  };

  render() {
    const { classes } = this.props;
    const { sortByValue, filter, sort, loadingContent } = this.context;

    const sortLabel = sortByValue ? sortByValue.replace('cm:', '').replace('content.', '').toLowerCase() : 'cm:name';

    return (
      <div className="Sort-By-Value">
        <ButtonGroup>
          <Button
            disabled={Boolean(filter) || loadingContent}
            onClick={this.handleSortClick}
            classes={{ root: classes.button }}
            id="sortByDirectionBtn"
          >
            {sort ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />}
          </Button>
          <Button
            disabled={Boolean(filter) || loadingContent}
            onClick={this.handleDropDownClick}
            endIcon={<ArrowDropDown fontSize="small" />}
            classes={{
              root: classes.button,
              label: classes.label,
            }}
            id="sortByDropdownBtn"
          >
            {window.Alfresco.messages.global[`label.${sortLabel}`]}
          </Button>
        </ButtonGroup>
        <Popover
          open={this.state.anchor !== null}
          anchorEl={this.state.anchor}
          onClose={this.closeMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuList>
            <MenuItem onClick={() => this.handleOnClick('cm:name')} id="sortByNameBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.name']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('cm:title')} id="sortByTitleBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.title']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('cm:description')} id="sortByDescriptionBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.description']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('cm:created')} id="sortByCreatedBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.created']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('cm:creator')} id="sortByNameBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.creator']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('cm:modified')} id="sortByModifiedBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.modified']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('cm:modifier')} id="sortByModifierBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.modifier']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('cm:content.size')} id="sortBySizeBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.size']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('cm:content.mimetype')} id="sortByMimetypeBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.mimetype']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleOnClick('TYPE')} id="sortByTypeBtn">
              <ListItemText primary={window.Alfresco.messages.global['label.type']} />
            </MenuItem>
          </MenuList>
        </Popover>
      </div>
    );
  }
}

SortByValue.contextType = ContentContext;

export default withStyles(styles)(SortByValue);
